import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Dashboard.module.css';
import DataTable from '../../components/common/DataTable';
import axios from 'axios';
import { API_BASE_URL } from '../../apiConfig';

export default function Dashboard() {
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);

  // 신규회원 가입 수 - 1주일 1달 기준
  const [stats, setStats] = useState({
    weeklyNewMembers: 0,
    monthlyNewMembers: 0
  });

  
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/v1/admin/users/count-user`)
    .then(response => {
      console.log('response:', response.data);
      if (response.data.code === 1) {
        const data = response.data.data;
        console.log('data: ', data);
        setStats({
          weeklyNewMembers: data.weekly,
          monthlyNewMembers: data.monthly
        });
      } else {
        console.error('Failed to fetch user count')
      }
    })
    .catch(err => console.error(err));
  }, []);

    // 오늘 필터 교체한 회원 데이터 패치
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/v1/filter-history/today`)
    .then(response => {
      console.log('filter history response:', response.data);
      if (response.data.code === 1) {
        const data = response.data.data;
        if (data && data.length > 0) {
          const transformedData = data.map(item => ({
            id: item.userId,
            name: item.name,
            change_date: item.createdAt
          }));
          setMembers(transformedData);
        } else {
          setMembers([]);
        }
      } else {
        console.error('Failed to fetch filter history');
        setMembers([]);
      }
    })
    .catch(err => {
      console.error(err);
      setMembers([]);
    });
  }, []);

  // row 클릭
  const handleRowClick = (user) => {
    navigate(`/users/${user.id}`);
  };

  // table 이름
  const columns = [
    {
      title: '이름',
      dataIndex: 'name',
      width: '100px'
    },
    {
      title: '교체 일자',
      dataIndex: 'change_date',
      width: '150px',
      render: (dateTime) => {
        // 날짜 형식 변환 (2025-08-31T09:11:24 -> 2025-08-31 09:11)
        const date = new Date(dateTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }
    }
  ];

  const StatCard = ({ count, period }) => (
    <div className={styles.statCard}>
      <div className={styles.statPeriod}>{period}</div>
      <div className={styles.statCount}>
        {count} <span className={styles.statUnit}>명</span>
      </div>
    </div>
  );

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.statsSection}>
        <h2 className={styles.sectionTitle}>신규 가입 회원 수</h2>
        <div className={styles.stateNumBox}>
          <StatCard period="최근 1주일" count={stats.weeklyNewMembers} />
          <StatCard period="최근 1달" count={stats.monthlyNewMembers} />
        </div>
      </div>

      <div className={styles.membersSection}>
        <h2 className={styles.sectionTitle}>오늘 필터 교체한 회원</h2>
        <div className={styles.memberDataTable}>
          <DataTable
            columns={columns}
            data={members}
            onRowClick={handleRowClick}
          />
        </div>
      </div>
    </div>
  );
}